import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { BlockRenderer } from "../components/block_renderer";
import { Jumbo } from "../components/jumbo";
export class HomePage extends React.Component {
    componentDidMount() {
        document.title = this.props.pageTitle;
    }
    updateInput(i, c) {
        this.setState((s, _)=>({
                ...s,
                input: i
            }), c);
    }
    render() {
        const p = this.props;
        const s = this.state;
        return /*#__PURE__*/ _jsx(_Fragment, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "home",
                children: [
                    /*#__PURE__*/ _jsx(Jumbo, {
                        title: p.headerTitle,
                        contents: p.description,
                        imageUrlSmall: p.phImageUrlSmall,
                        imageUrl: p.phImageUrl,
                        imageUrlFallback: p.phImageUrlFallback,
                        imageUrlLarge: p.phImageUrlLarge,
                        imageAlt: p.imageAlt,
                        buttonTitle: p.headerButtonTitle,
                        buttonUrl: p.headerButtonUrl,
                        size: "large",
                        kind: "home",
                        localizationProps: p.localizationProps
                    }),
                    /*#__PURE__*/ _jsx(BlockRenderer, {
                        blocks: p.universalBlocks
                    }),
                    /*#__PURE__*/ _jsx(BlockRenderer, {
                        blocks: p.blocks
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props);
        this.state = {
            input: ""
        };
        this.updateInput = this.updateInput.bind(this);
    }
}
{}